class ConfigurationController extends AbstractController
	@register()
	@inject 'configurations',
		'ConfigurationService'
		'UserInformation'

	initialize: ->
		@modelName = 'master_users'
		@masterUser = @UserInformation.getMasterUser()

		@configurationFilter = [
			'!Backoffice.Setting.Order.Status.'
		]
